// "https://azusc-pkgloop-admin-web-dev.azurewebsites.net/api/v1.0/customer-portal/pre-built-packages/get/1"
import "../../WidgetModal.css";
import "react-day-picker/lib/style.css";

import React, { useState, useEffect, SetStateAction, useContext } from "react";
import { Col, Row, Form, Modal, Spinner, Button } from "react-bootstrap";
import DayPickerInput from "react-day-picker/DayPickerInput";
// import { Modifier } from "react-day-picker/types/common";
import VendorCard from "../../VendorCard";
import { DatesAndGuests } from "../../../../widget-form/WidgetForm";
import { WidgetContext } from "../../../../../../../context/WidgetContext";
import ViewPort from "../../../../../../../_helpers/Enums/ViewPortEnum";
import UseGetPackages, { GetPackagesRequest, GetPackagesResponse } from "./data-service-hooks/UseGetPreBuiltPackages";
import PackagesCard from "../packages-card/PackagesCard";
import PackageDetails from "../package-details/PackageDetails";
import { PreBuiltPkg } from "../Models/PreBuiltPkg";
import CustomDayPickerInput from "../../../../../customDayPickerInput/CustomDayPickerInput";
import reactMoment from "react-day-picker/moment";
import moment from "moment";
import { Modifier } from "react-day-picker";
import SwitchToggle from "../../../../../switchToggle/SwitchToggle";
import { PreBuiltPkgBrand } from "../Models/PreBuiltPkgBrand";

interface props {
  show: boolean,
  onHide: () => void;
  brandId: number,
  datesAndGuestsState: [DatesAndGuests, React.Dispatch<SetStateAction<DatesAndGuests>>];
  // datesAndGuests: DatesAndGuests;
  onSelectedPackage: (pkg: PreBuiltPkg) => void;
}

enum SortByOption {
  NONE = "none",
  DATE = "date",
  BRAND = "brand",
}

// Default brand id for when the user has not selected a brand
const DEFAULT_BRAND_ID = -1;

const AddPreBuiltPackageModal: React.FC<props> = (props) => {
  const { startWidget, style, viewPortBreakPoint, brandSettings } = useContext(WidgetContext);
  const { show, onHide, brandId, onSelectedPackage } = props;
  const [packages, setPackages] = useState<any>();
  const [datesAndGuests, setDatesAndGuests] = props.datesAndGuestsState;
  const [selectedPackage, setSelectedPackage] = useState<PreBuiltPkg>();
  // const { formatDate, parseDate } = moment;
  // const modifiers = { start: datesAndGuests.fromDate, end: datesAndGuests.toDate };

  const [getPackagesRequest, setGetPackagesRequest] = useState<GetPackagesRequest>();
  const responseGetPackages = UseGetPackages(getPackagesRequest);
  const { formatDate, parseDate } = reactMoment;
  const modifiers = { start: datesAndGuests.fromDate, end: datesAndGuests.toDate };

  const [simpleView, setSimpleView] = useState(viewPortBreakPoint < ViewPort.lg);
  const [sortBy, setSortBy] = useState<SortByOption>(SortByOption.NONE);
  const [sortByBrand, setSortByBrand] = useState<number>();
  const [sortByDateArrive, setSortByDateArrive] = useState<Date>(datesAndGuests.fromDate || new Date());
  const [sortByDateDepart, setSortByDateDepart] = useState<Date>(datesAndGuests.toDate || new Date());
  // const onSelectedPackage = (pkg: any) => {
  //   setSelectedPackage(pkg);
  // }

  const handlePackageSelection = (pkg: PreBuiltPkg) => {
    // Adjust dates if needed to fit within package travel period
    const validFrom = moment(pkg.validToTravelFrom).startOf('day').toDate();
    const validTo = moment(pkg.validToTravelEnd).startOf('day').toDate();
    
    if (datesAndGuests.fromDate < validFrom || datesAndGuests.fromDate > validTo) {
      datesAndGuests.fromDate = validFrom;
      setSortByDateArrive(validFrom);
    }
    if (datesAndGuests.toDate > validTo || datesAndGuests.toDate < validFrom) {
      datesAndGuests.toDate = validTo;
      setSortByDateDepart(validTo);
    }
    
    setDatesAndGuests({ ...datesAndGuests });
    setSelectedPackage(pkg);
  };

  useEffect(() => {
    if (brandId === undefined || brandId === -1 || brandId === null) return;
    setPackages(undefined);

    let fromDateString = datesAndGuests.fromDate ? datesAndGuests.fromDate.toLocaleDateString("en-US").replace("/", "-") : "";
    fromDateString = fromDateString.replace("/", "-");
    let toDateString = datesAndGuests.toDate ? datesAndGuests.toDate.toLocaleDateString("en-US").replace("/", "-") : "";
    toDateString = toDateString.replace("/", "-");
    setGetPackagesRequest({ brandId, startDate: fromDateString, endDate: toDateString });
  }, [brandId, datesAndGuests]);

  useEffect(() => {
    if (responseGetPackages.data) {
      let responseData: GetPackagesResponse = responseGetPackages.data;
      setPackages(responseData.packages.sort((a: any, b: any) => {
        if (a.displayOrder < b.displayOrder) return -1;
        if (a.displayOrder > b.displayOrder) return 1;

        return 0;
      }));
    }
  }, [responseGetPackages.data]);

  useEffect(() => {
    if (sortBy === SortByOption.BRAND && sortByBrand !== -1) {
      setPackages(responseGetPackages.data?.packages?.filter((pkg: PreBuiltPkg) => pkg.preBuiltPkgBrands.some((brand: PreBuiltPkgBrand) => brand.brandId === sortByBrand)));
    } else if (sortBy === SortByOption.DATE && sortByDateArrive !== undefined && sortByDateDepart !== undefined) {
      setPackages(responseGetPackages.data?.packages.filter((pkg: PreBuiltPkg) => {
        // Use moment to parse dates to avoid timezone issues
        const travelFromDate = moment(pkg.validToTravelFrom).startOf('day').toDate();
        const travelEndDate = moment(pkg.validToTravelEnd).startOf('day').toDate();
        
        // Reset times to midnight to compare dates only
        const arriveDate = moment(sortByDateArrive).startOf('day').toDate();
        const departDate = moment(sortByDateDepart).startOf('day').toDate();

        // Include packages with invalid dates or where dates are within range
        return isNaN(travelFromDate.getTime()) || 
               isNaN(travelEndDate.getTime()) ||
               (travelFromDate <= arriveDate && travelEndDate >= departDate);
      }));
    } else {
      // use default priority sorting if no sorting is selected
      setPackages(responseGetPackages.data?.packages.sort((a: any, b: any) => {
        if (a.displayOrder < b.displayOrder) return -1;
        if (a.displayOrder > b.displayOrder) return 1;
        return 0;
      }));
    }
  }, [sortBy, sortByBrand, sortByDateArrive, sortByDateDepart, responseGetPackages.data]);

  return (
    <React.Fragment>
      <Modal
        scrollable={true}
        size="lg"
        show={show && !!!selectedPackage}
        onHide={onHide}
        backdropClassName="white-overlay"
        dialogClassName="box-shadow mobile-full-width"
      >
        <Modal.Header translate="" closeButton closeLabel="close window">
          <div className="w-100">
            <Modal.Title style={{ color: style.fontColor }} className="">Package Specials</Modal.Title>
            {/* <Row className="">
              <p style={{ color: style.fontColor }} className="itinerary-info mr-2 mb-0"><span><i className="far fa-calendar-alt"></i></span> {datesAndGuests.fromDate ? datesAndGuests.fromDate.toDateString() : "Arrive"}</p>
              <p style={{ color: style.fontColor }} className="itinerary-info mb-0"> - </p>
              <p style={{ color: style.fontColor }} className="itinerary-info ml-2 mb-0"><span><i className="far fa-calendar-alt"></i></span> {datesAndGuests.toDate ? datesAndGuests.toDate.toDateString() : "Depart"}</p>
            </Row> */}
            <Row className="mt-3">
              <Col xs={12} md={6}>
                <Form.Control
                  className=""
                  style={{ color: style.fontColor }}
                  as="select"
                  name="sortByFilters"
                  onChange={(e) => setSortBy(e.target.value as SortByOption)} >
                  <option value={SortByOption.NONE}>Sort By - Default</option>
                  <option value={SortByOption.DATE}>Sort By - Date</option>
                  {brandSettings && brandSettings.length > 1 && (
                    <option value={SortByOption.BRAND}>Sort By - Brand</option>
                  )}
                </Form.Control>
              </Col>
            </Row>
            {/* DAY PICKERS */}
            {sortBy === SortByOption.DATE && (
              <Row className="mt-3">
                <Col xs={12} md={6} className="InputFromTo d-flex flex-column mb-2">
                  {/*<Form.Label className="font-weight-bold" style={{ color: style.fontColor }}>
                    Arrive
                {/* {errors.length > 0 && errors.find(e => e.id == "fromDate") && (
                  <span className="small font-italic text-danger"> {errors.find(e => e.id == "fromDate").message}</span>
                )}
                  </Form.Label> */}
                  <CustomDayPickerInput
                    value={`Arrive: ${moment(sortByDateArrive).format("ddd, MMM Do, YYYY")}`}
                    placeholder="From"
                    format="LL"
                    formatDate={formatDate}
                    parseDate={parseDate}
                    inputProps={{ required: "required", style: { color: style.fontColor } }}
                    style={{ width: '100%' }}
                    dayPickerProps={{
                      selectedDays: { from: sortByDateArrive, to: sortByDateDepart } as Modifier,
                      disabledDays: { before: new Date() },
                      numberOfMonths: 1,
                      month: new Date(sortByDateArrive),
                      modifiers,
                    }}
                    onDayChange={(date: Date) => {
                      datesAndGuests.fromDate = date;
                      if (datesAndGuests.toDate && date > datesAndGuests.toDate) {
                        datesAndGuests.toDate = date;
                        setSortByDateDepart(new Date(date));
                      }
                      setDatesAndGuests({ ...datesAndGuests });
                      setSortByDateArrive(date);
                    }}
                  />
                </Col>

                <Col xs={12} md={6} className="InputFromTo d-flex flex-column mb-3">
                  {/*<Form.Label className="font-weight-bold" style={{ color: style.fontColor }}>
                    Depart
                {/* {errors.length > 0 && errors.find(e => e.id == "toDate") && (
                  <span className="small font-italic text-danger"> {errors.find(e => e.id == "toDate").message}</span>
                )} 
                  </Form.Label> */}

                  <CustomDayPickerInput
                    value={`Depart: ${moment(sortByDateDepart).format("ddd, MMM Do, YYYY")}`}
                    placeholder="To"
                    format="LL"
                    formatDate={formatDate}
                    parseDate={parseDate}
                    inputProps={{ required: "required", style: { color: style.fontColor } }}
                    style={{ width: '100%' }}
                    dayPickerProps={{
                      selectedDays: { from: new Date(sortByDateArrive), to: new Date(sortByDateDepart) } as Modifier,
                      disabledDays: { before: sortByDateArrive as Date },
                      modifiers,
                      month: new Date(sortByDateArrive),
                      fromMonth: new Date(sortByDateArrive),
                      numberOfMonths: 1
                    }}
                    onDayChange={(date: Date) => {
                      datesAndGuests.toDate = date;
                      setDatesAndGuests({ ...datesAndGuests });
                      setSortByDateDepart(new Date(date));
                    }}
                  />
                </Col>
              </Row>
            )}
            {sortBy === SortByOption.BRAND && (
              <Row className="mt-3">
                <Col xs={12} md={6}>
                  <Form.Control
                    className=""
                    style={{ color: style.fontColor }}
                    as="select"
                    name="brandFilters"
                    onChange={(e) => setSortByBrand(Number(e.target.value))}>
                    <option value={DEFAULT_BRAND_ID}>Select Brand</option>
                    {brandSettings && brandSettings.map((setting, index) => (
                      <option value={setting.brand.brandId} key={`brand_${index}`}>{setting.brand.brandName}</option>
                    ))}
                  </Form.Control>
                </Col>
              </Row>
            )}
            {viewPortBreakPoint < ViewPort.lg && (
              <div style={{ display: 'flex', marginLeft: 'auto', marginRight: 0, justifyContent: 'end', marginTop: '10px' }}>
                <p style={{ marginTop: '-4px', marginRight: '4px' }}>Simple View</p>
                <SwitchToggle checked={simpleView} id={"add-modal-1"} onChange={setSimpleView} />
              </div>
            )}
          </div>

        </Modal.Header>
        <Modal.Body>
          <Row className="d-flex justify-content-center">
            <Col xs={12}>
              {responseGetPackages.isLoading && (
                <span><Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                /> Loading...</span>
              )}
              {packages && packages.length == 0 && (
                // manually setting the height to accommodate day pickers
                <p className="font-italic text-dark" style={{ height: '250px' }}>No results found</p>
              )}
              {packages && packages.map((pkg: any, index: number) => (
                <PackagesCard
                  key={`${1}-${index}`}
                  pbPackage={pkg}
                  onSelectedPackage={() => handlePackageSelection(pkg)}
                  stacked={false}
                  simpleView={simpleView}
                />
              ))}
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

      <Modal
        show={!!selectedPackage}
        size="lg"
        onHide={() => {
          setSelectedPackage(undefined);
        }}
        backdropClassName="white-overlay"
        dialogClassName="box-shadow"
      >
        <Modal.Header translate="" closeButton closeLabel="close window">
          <div className="w-100">
            <Modal.Title className="font-weight-bold">{selectedPackage ? selectedPackage.packageName : "undefined"}</Modal.Title>
            <Row className="mt-3">
              <Col xs={12} md={6} className="InputFromTo d-flex flex-column mb-2">
                <CustomDayPickerInput
                  value={`Arrive: ${moment(sortByDateArrive).format("ddd, MMM Do, YYYY")}`}
                  placeholder="From"
                  format="LL"
                  formatDate={formatDate}
                  parseDate={parseDate}
                  inputProps={{ required: "required", style: { color: style.fontColor } }}
                  style={{ width: '100%' }}
                  dayPickerProps={{
                    selectedDays: {
                      from: sortByDateArrive,
                      to: sortByDateDepart
                    },
                    disabledDays: { 
                      before: moment(selectedPackage?.validToTravelFrom).toDate(),
                      after: moment(selectedPackage?.validToTravelEnd).toDate()
                    },
                    modifiers,
                    month: sortByDateArrive,
                  }}
                  onDayChange={(date: Date) => {
                    if (!date) return;
                    setSortByDateArrive(date);
                    datesAndGuests.fromDate = date;
                    if (datesAndGuests.toDate && date > datesAndGuests.toDate) {
                      datesAndGuests.toDate = date;
                      setSortByDateDepart(date);
                    }
                    setDatesAndGuests({ ...datesAndGuests });
                  }}
                />
              </Col>

              <Col xs={12} md={6} className="InputFromTo d-flex flex-column mb-3">
                <CustomDayPickerInput
                  value={`Depart: ${moment(sortByDateDepart).format("ddd, MMM Do, YYYY")}`}
                  placeholder="To"
                  format="LL"
                  formatDate={formatDate}
                  parseDate={parseDate}
                  inputProps={{ required: "required", style: { color: style.fontColor } }}
                  style={{ width: '100%' }}
                  dayPickerProps={{
                    selectedDays: { from: sortByDateArrive, to: sortByDateDepart },
                    disabledDays: { 
                      before: moment(selectedPackage?.validToTravelFrom).toDate(),
                      after: moment(selectedPackage?.validToTravelEnd).toDate()
                    },
                    month: sortByDateArrive,
                    fromMonth: sortByDateArrive,
                    numberOfMonths: 1
                  }}
                  onDayChange={(date: Date) => {
                    if (!date) return;
                    setSortByDateDepart(date);
                    datesAndGuests.toDate = date;
                    setDatesAndGuests({ ...datesAndGuests });
                  }}
                />
              </Col>
            </Row>
            <div className="d-flex flex-row justify-content-between m-0 p-0">
              {/*<p className="font-weight-bold orange-text m-0 p-0">{selectedPackage ? selectedPackage.description : "Description"}</p>*/}
              {selectedPackage && (
                <Button className={`orange-button ${viewPortBreakPoint < ViewPort.lg ? 'w-50' : 'w-25'}`} onClick={() => onSelectedPackage(selectedPackage)}>Add To Itinerary</Button>
              )}
              <p className="font-weight-bold green-text m-0 p-0 mt-2">From ${selectedPackage ? selectedPackage.fromPrice : ""}</p>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          {selectedPackage && (
            <PackageDetails
              pbPackage={selectedPackage}
              datesAndGuests={datesAndGuests}
              onSelectedPackage={(pkg: any) => {
                onHide();
                onSelectedPackage(pkg);
              }}
            />
          )}
        </Modal.Body>
      </Modal>

    </React.Fragment>
  )
}

export default AddPreBuiltPackageModal
